(function Module() {
	'use strict';

	mySynch.controller('ConfirmationController', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'$timeout',
		function ConfirmationController($s, MSF, api, $timeout) {
			var confirmationModal = $('#confirmation-modal');
			var defaults = {
				options: {
					title: 'Please Confirm',
					message: 'Are you sure?',
					confirm: {
						className: 'primary',
						icon: 'check',
						text: 'Yes'
					},
					cancel: {
						className: 'default',
						icon: 'times',
						text: 'Cancel'
					}
				},
				confirmCallback: function confirmed() {
					return true;
				},
				cancelCallback: function cancelled() {
					return false;
				}
			};
			var stockConfirmations = {
				unsavedChanges: _.merge({}, defaults.options, {
					title: 'Unsaved Changes',
					message: MSF.unsavedChangesConfirmationMessage,
					cancel: {
						className: 'default',
						icon: 'times',
						text: 'No'
					}
				})
			};

			$s.confirmation = _.cloneDeep(defaults.options);

			$s.resolveCallback = function resolveCallback(confirmed) {
				confirmationModal.unbind();

				confirmationModal.one('hidden.bs.modal', function onModalHidden(e) {
					$s.confirmation[(confirmed ? 'confirm' : 'cancel') + 'Callback']();
				});

				confirmationModal.modal('hide');
			};

			$s.$on('message:confirmation', function confirmationReceived(scope, options, confirmCallback, cancelCallback) {
				$s.confirmation = _.merge({}, defaults.options, {
					confirmCallback: confirmCallback || defaults.confirmCallback,
					cancelCallback: cancelCallback || defaults.cancelCallback
				}, stockConfirmations[options] || options); // If options is a string, use stock confirmations

				confirmationModal.modal('show');
				confirmationModal.one('hidden.bs.modal', function onModalHidden(e) {
					$s.confirmation.cancelCallback();
				});
			});

			$s.deleteNotification = function deleteNotification(notification) {
				$s.notifications = _.without($s.notifications, notification);
			};
		}
	]);
})();
